import React from 'react'

export default function Description(props) {
  return (
    <div className="col-12 col-md-9">
            <div className="col-12 pt-3">
              <div className="row">
                <div className="col-12 col-md-4 col-lg-3">
                  <h4>Description:</h4>
                </div>
                <div className="col-12 col-md-8 col-lg-9">
                  <p className="text-justify">{props.description}</p>
                  <p className="text-justify">{props.description2}</p>
                  <p className="text-justify">{props.description3}</p>
                </div>
              </div>
            </div>
          </div>
  )
}
